import React from "react";
import { Select } from "antd";
import GainIcon from "../gainicon";

const { Option } = Select;
export default function GainSelect(props) {
  return (
    <div>
      <div>
        <label className="text-base whitespace-nowrap">
          {props.label
            ? props.label
            : !props.nospace && <div className="opacity-0">Hidden</div>}
        </label>
      </div>
      <Select
        mode={props.multiple ? "multiple" : false}
        defaultValue={props.default}
        placeholder="Select"
        onChange={props.onChange}
        dropdownClassName="rounded-lg"
        className="text-black w-full text-base font-light pt-1"
        suffixIcon={<GainIcon name="arrow-down" />}
        value={props.value}
        disabled={props.disabled}
        value={props.value}
        maxTagCount={props.maxTagCount ? "responsive" : false}
      >
        {props.options?.map((item, i) => (
          <Option key={`key-${i}`} value={props.useId ? item.id : item.value}>
            {item.name}
          </Option>
        ))}
      </Select>
    </div>
  );
}
